import { put, call } from "redux-saga/effects";
import Axios from "../../utils/axios";
import { fetchClientDone, fetchClientError } from "../../state/client/actions";
import { STRETCH_FETCH_CLIENT_BY_SHORTNAME } from "../../state/client/constants";
import { PageView, initGA } from "../../ga-tracker";
import { setItemOnLS } from "../../utils/util";

function* fetchClient({ shortName }) {
  try {
    const result = yield call(
      Axios.core.get,
      `${STRETCH_FETCH_CLIENT_BY_SHORTNAME}/${shortName}`
    );
    if (!result.data.enabled) throw new Error();
    yield put(fetchClientDone(result));
    yield setItemOnLS("c_sh_n", shortName);

    // TODO Update Jenkins file??
    const { useGA4, googleAnalyticsKey } = result.data.features.ads;
    const {
      REACT_APP_PRESTO_GA_TRACKING_ID: trackingId,
      REACT_APP_PRESTO_GA4_TRACKING_ID: trackingId4
    } = process.env;
    const trackingInternal = useGA4 ? trackingId4 : trackingId;

    initGA(trackingInternal, googleAnalyticsKey, useGA4);
    PageView();
  } catch (e) {
    yield put(fetchClientError(e));
    yield setItemOnLS("c_sh_n", null);
  }
}

export default fetchClient;
